import { render, staticRenderFns } from "./UsernameItem.vue?vue&type=template&id=50d48e4c"
import script from "./UsernameItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UsernameItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports